import type { NotificationKey, NotificationPrefKey, NotificationPrefs } from '@erp/shared';

export type { NotificationKey, NotificationPrefKey };

/** Chave ausente nas prefs = notificação habilitada. */
export function isPrefEnabled(
  prefs: NotificationPrefs | undefined,
  key: NotificationPrefKey
): boolean {
  return prefs?.[key] ?? true;
}
